import React, { memo } from 'react';
import { Icon } from '@ant-design/react-native';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { TouchableOpacity, View, Text } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { colorPalette } from '@shared/config/colorsConfig';
interface HistoryHeaderProps {
  currentDate: Date;
  handleDateChange: (days: number) => void;
  canNavigateForward?: boolean;
}

const NAV_BUTTON_SIZE = 36;
const NAV_ICON_SIZE = 20;
const PRIMARY_COLOR = colorPalette.primary[600];
const DISABLED_COLOR = colorPalette.gray[400];
const BORDER_COLOR = colorPalette.gray[400];

const HistoryHeader: React.FC<HistoryHeaderProps> = memo(({
  currentDate,
  handleDateChange,
  canNavigateForward = true,
}) => {
  const insets = useSafeAreaInsets();

  const formattedDate = format(currentDate, 'MMMM yyyy', { locale: it });

  const NavButton = ({ direction }: { direction: 'left' | 'right' }) => {
    const isDisabled = direction === 'right' && !canNavigateForward;

    return (
      <TouchableOpacity
        className="rounded-full border justify-center items-center"
        style={{
          width: NAV_BUTTON_SIZE,
          height: NAV_BUTTON_SIZE,
          borderColor: BORDER_COLOR,
          opacity: isDisabled ? 0.4 : 1,
        }}
        onPress={() => !isDisabled && handleDateChange(direction === 'left' ? -1 : 1)}
        disabled={isDisabled}
      >
        <Icon
          name={direction}
          size={NAV_ICON_SIZE}
          color={isDisabled ? DISABLED_COLOR : PRIMARY_COLOR}
        />
      </TouchableOpacity>
    );
  };

  return (
    <View
      className="flex-row justify-between items-center "
    >
      <Text className="text-4xl font-bold" >
        {formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)}
      </Text>

      <View className="flex-row gap-5 mb-5">
        <NavButton direction="left" />
        <NavButton direction="right" />
      </View>
    </View>
  );
});

export default HistoryHeader;
